import { OrderFormat } from '@ancon/wildcat-types'

const GroupPreOrderUnsupportedOrderFormats = [OrderFormat.BoxPickup]

export default function isGroupOrderSupportedOrderFormat(
  orderFormat: OrderFormat,
) {
  return !GroupPreOrderUnsupportedOrderFormats.includes(orderFormat)
}
